const {keepOnly, equalDeep} = require("../../../utils/objects");

const isSameField = (field1, field2) => {
    const attrs = ["modelID", "modelTableID", "modelColumnID"];
    return equalDeep(keepOnly(field1, attrs), keepOnly(field2, attrs));
};

exports.isSameField = isSameField;
